export const hardCodedOptions: {[key: string]: string[]} = {
  modelRoles: ['Editor', 'Model Viewer', 'Calibration Modeler', 'Scenario Modeler', 'Model Display Viewer'],
};
